import React from 'react';
import PropTypes from 'prop-types';

//styles
import {
  ToggleSwitchWrapper,
  ToggleSwitchInput,
  ToggleSwitchSlider,
  ToggleSwitchText,
} from './index.styled';
import { FormGroup } from 'components/styled/Form.styled';
//components
import FormLabel from 'components/common/form/Label';

const ToggleSwitch = ({ name, description, error, disabled, label, isRequired, value, mb }) => {
  return (
    <FormGroup mb={mb}>
      {label && (
        <FormLabel isRequired={isRequired} label={label} name={name} error={error}></FormLabel>
      )}
      <ToggleSwitchWrapper>
        <ToggleSwitchInput type="checkbox" name={name} disabled={disabled} value={value} />
        <ToggleSwitchSlider error={error ? 'hasError' : 'noError'} disabled={disabled} />
      </ToggleSwitchWrapper>
      <ToggleSwitchText disabled={disabled}>{description}</ToggleSwitchText>
    </FormGroup>
  );
};

ToggleSwitch.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  error: PropTypes.any,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  value: PropTypes.string | PropTypes.bool,
  mb: PropTypes.string,
};

export default ToggleSwitch;
